import type { ReactNode } from "react";

export function FaqItem({
  question,
  answer,
}: {
  question: string;
  answer: ReactNode;
}) {
  return (
    <details className="group rounded-2xl border border-line bg-white p-5 open:shadow-sm">
      <summary className="cursor-pointer list-none text-base font-semibold text-ink marker:content-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40">
        {question}
      </summary>
      <div className="mt-3 max-w-[65ch] text-base leading-7 text-muted">{answer}</div>
    </details>
  );
}
